import { render, staticRenderFns } from "./DomainHelp.vue?vue&type=template&id=da24c49a&scoped=true"
import script from "./DomainHelp.vue?vue&type=script&lang=js"
export * from "./DomainHelp.vue?vue&type=script&lang=js"
import style0 from "./DomainHelp.vue?vue&type=style&index=0&id=da24c49a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da24c49a",
  null
  
)

export default component.exports